import React from 'react';

const icons: any = {
  systolic_pressure: (
    <img src={require('../../assets/svg/avatar-alert-blood-pressure.svg').default} alt="" />
  ),
  diastolic_pressure: (
    <img src={require('../../assets/svg/avatar-alert-blood-pressure.svg').default} alt="" />
  ),
  cholesterol: (
    <img src={require('../../assets/svg/avatar-alert-cholesterol.svg').default} alt="" />
  ),
  heart_rate: <img src={require('../../assets/svg/avatar-alert-hr.svg').default} alt="" />,
  glucose: <img src={require('../../assets/svg/avatar-alert-glucose.svg').default} alt="" />,
  temperature: (
    <img src={require('../../assets/svg/avatar-alert-temperature.svg').default} alt="" />
  ),
  breath_rate: (
    <img src={require('../../assets/svg/avatar-alert-breath_rate.svg').default} alt="" />
  ),
  oxygen_saturation: (
    <img src={require('../../assets/svg/avatar-alert-oxygen_saturation.svg').default} alt="" />
  ),
};

export const getIcon = (key: string) => {
  return icons[key] || null;
};
